import {clamp, json, texture} from "p3";
import common from "../../common";
import definitions from "../../definitions";
import GameScene from "../../scenes/GameScene";
import HealthBarHeart from "./HealthBarHeart";

export default class HealthBar extends PIXI.Container {
    constructor(characterIconTextureId="", allowShields=true) {
        super();

        this._health = 0;
        this._hearts = [];

        this._characterIcon = null;
        this._characterIconTextureId = characterIconTextureId;

        this._allowShields = allowShields;

        this._panel = null;
        //this._emptyContainer = null;
        this._panelContents = null;

        this._effectIcons = null;

        this.init();
    }

    init() {
        this._panel = new PIXI.NineSlicePlane(texture("panel_lives_bg"), 40, 0, 40, 0);
        this.addChild(this._panel);

        this._panelContents = new PIXI.Container();
        this.addChild(this._panelContents);

        this._setCharacterIcon();
    }

    update() {
        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            this._hearts[i].update();
        }
    }

    /**
     * @param {number} count
     * @param {boolean} [animate=false]
     */
    setHearts(count, animate = false) {
        this._health = count * 4;
        this._removeHearts();

        let shieldOffset = 0;

        if (this._allowShields) {
            
            const equipment = json('equipment');
    
            for (let i in definitions.EQUIPPABLES) {
                for (let j in equipment) {
                    for (let k in equipment[j]) {
                        
                        if (equipment[j][k].id == common.saveData.activeSlot.player[definitions.EQUIPPABLES[i]] && equipment[j][k].stats) {
                            //console.log(equipment[j][k].id, common.saveData.activeSlot.player[definitions.EQUIPPABLES[i]]);
                            if (equipment[j][k].stats.health) {
                                shieldOffset += equipment[j][k].stats.health;
                            }
                        }
                    }
                }
            }
        }
       // console.log('SHIELD OFFSET:', shieldOffset);

        for (let i = 0; i < count; ++i) {
            const heart = new HealthBarHeart(Math.min(4, (count - i) * 4), i >= count - shieldOffset);
            heart.position.set(this._panelContents.width + (heart.width/2), 24);
            this._panelContents.addChild(heart);
            this._hearts[i] = heart;

            animate && heart.animateIn(i * 0.024).then();
        }

        if (this._characterIcon == null) {
            this._setEffectIcons();

            for (let i in this._effectIcons) {
                this._effectIcons[i].x = this._panelContents.width;
                this._panelContents.addChild(this._effectIcons[i]);
            }
        }

        this._panel.width = this._panelContents.width + this._panel.leftWidth + this._panel.rightWidth;
        this._panel.x = -this._panel.width/2;
        this._panelContents.x = -this._panelContents.width/2;
    }

    updateEffectValue(effectId, value) {
        for (let i in this._effectIcons) {
            if (this._effectIcons[i].id == effectId) {
                this._effectIcons[i].value.text = value;
                gsap.killTweensOf(this._effectIcons[i].icon.anchor);
                if (value == 0) {
                    this.setHearts(common.saveData.activeSlot.player.hearts);
                } else {
                    const tl = new gsap.timeline();
                    GameScene.active.addTween(tl);
                    this._effectIcons[i].icon.anchor.y = 0;
                    tl.to(this._effectIcons[i].icon.anchor, 0.1, {y:0.2, ease:Sine.easeOut});
                    tl.to(this._effectIcons[i].icon.anchor, 0.3, {y:0, ease:Back.easeOut});
                }
            }
        }
    }

    /**
     * @private
     */
    _setCharacterIcon() {
        if (this._characterIconTextureId !== "") {
            this._characterIcon = new PIXI.Sprite(texture(this._characterIconTextureId));
            this._characterIcon.y = -15;
            this._panelContents.addChild(this._characterIcon);
        }
    }

    /**
     * @private
     */
    _removeHearts() {
        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            this._hearts[i].destroy();
            this._panelContents.removeChild(this._hearts[i]);
        }
        this._hearts.length = 0;
        for (let i in this._effectIcons) {
            this._panelContents.removeChild(this._effectIcons[i]);
        }

        //this._emptyContainer.removeChildren();
    }

    /**
     * @private
     */
    _setEffectIcons() {

        this._effectIcons = [];

        const playerData = common.saveData.activeSlot.player;
        if (playerData.effects == null) {
            return;
        }

        const effects = [
            {effect: definitions.EFFECTS.SNAKE_PROTECTION, icon:"icon_snake_repellant_health"},
            {effect: definitions.EFFECTS.SPIDER_PROTECTION, icon:"icon_spider_repellant_health"},
            {effect: definitions.EFFECTS.SUPER_PROTECTION, icon:"icon_super_repellant_health"},
        ]; 
        for (let i in effects) {
            if (playerData.effects[effects[i].effect] > 0) {
                let container = new PIXI.Container();
                container.id = effects[i].effect;
                let icon = new PIXI.Sprite(texture(effects[i].icon));
                icon.scale.set(0.9);
                container.addChild(icon);
                container.icon = icon;

                let value = new PIXI.BitmapText("00", {
                    fontName: "Alghera Pro",
                    fontSize: 26,
                    align: "right",
                    tint: 0xd34a38
                });
                value.position.set(icon.width - 5, 13);
                value.text = playerData.effects[effects[i].effect];
                container.addChild(value);
                container.value = value;
                this._effectIcons.push(container);
            }
        }
    }

    /**
     * @return {number}
     */
    get health() {
        return this._health;
    }

    /**
     * @param {number} value
     */
    set health(value) {
        const lastHealth = this._health;
        this._health = clamp(value, 0, this.healthMax);
        const animate = this._health !== lastHealth;

        for (let i = 0, count = this._hearts.length; i < count; ++i) {
            const heart = this._hearts[i];
            heart.health = value - i * 4;
            heart.warning = value <= this.healthMax * 0.5;
            animate && heart.animateIn();
        }
    }

    /**
     * @return {number}
     */
    get healthMax() {
        let val = 0;
        for (let i in this._hearts) {
            val += this._hearts[i].maxHealth;
        }
        return val;
        //return 4 * this._hearts.length;
    }
}